import { render, staticRenderFns } from "./ShopifyStockEdit.vue?vue&type=template&id=81fc8bb8&"
import script from "./ShopifyStockEdit.vue?vue&type=script&lang=js&"
export * from "./ShopifyStockEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShopifyStockEdit.vue"
export default component.exports